import { Vue, Component } from "vue-property-decorator";
import { store } from '@/store';
import MyMap from './MyMap/index.vue'
import Campaigns from './campaigns/index.vue'
import { Series } from '@/galaxy-cruise/api_interface';
import { asyncAlert } from '@/galaxy-cruise/components/AsyncAlert';
import EndingMessageSeason1 from "@/galaxy-cruise/pages/MainPage/QuestionPanel/MessageWindows/SeriesDone/Default/index.vue";
import { i18nTranslate } from '@/i18n';

@Component({
  components: { MyMap, Campaigns },
})
export default class extends Vue {
  get gc() {
    return store.galaxyCruise
  }

  get user() {
    return this.gc.session!.user
  }

  get answersCount() {
    return this.gc.session!.record.answers_count + this.gc.doneGalaxies.length
  }

  get cabinGrade() {
    return this.gc.cabinGrade
  }

  get cabinGradeWithTh() {
    switch (this.gc.cabinGrade) {
      case 1:
        return '1<sup>st</sup>'
      case 2:
        return '2<sup>nd</sup>'
      case 3:
        return '3<sup>rd</sup>'
      default:
        return `${this.gc.cabinGrade}<sup>th</sup>`
    }
  }

  get cabinGradeHtml() {
    const dict0 = {
      ja: "特等客室",
      en: "Cabin Class Deluxe",
    }
    const dict = {
      ja: "{cabinGrade}等客室",
      en: "Cabin Class {cabinGradeWithTh}",
    }
    const { cabinGrade, cabinGradeWithTh } = this
    const html = i18nTranslate(this.cabinGrade <= 0 ? dict0 : dict, { cabinGrade, cabinGradeWithTh })
    return html
  }

  showEndingMessage(close: () => void, series: Series) {
    close()
    asyncAlert({ component: EndingMessageSeason1 })
  }
}
